/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Companion World API
 * API for managing virtual worlds populated with AI-driven agents.

## Overview
The Companion World API provides endpoints for:
- Creating and managing virtual worlds
- Generating populations of AI agents
- Managing agent activities and calendars
- Configuring locations and demographics

## Authentication
Currently, the API operates without authentication. This will be updated in future versions.

## Async Operations
Long-running operations (like population generation) return job IDs for status polling.

 * OpenAPI spec version: 1.0.0
 */

/**
 * Content rating for appropriate audience
 */
export type CreateUploadUrlRequestAudienceRating =
  (typeof CreateUploadUrlRequestAudienceRating)[keyof typeof CreateUploadUrlRequestAudienceRating];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateUploadUrlRequestAudienceRating = {
  G: 'G',
  PG: 'PG',
  'PG-13': 'PG-13',
  R: 'R',
  'NC-17': 'NC-17',
} as const;
